import {
    LoaderComponent as SourceLoaderComponent,
} from 'SourceComponent/Loader/Loader.component';
import React from 'react';
import './Loader.override.style';
import diamond from "../../assets/diamond.svg";
import LoaderDiamondIcon from 'Component/LoaderDiamondIcon';

export class LoaderComponent extends SourceLoaderComponent {
    render() {
        const { isLoading, mix } = this.props;

        if (!isLoading) {
            return null;
        }

        return (
            <div className="Loader">
                <div className="Loader-Scale">
                    <span className='loader-47'>
                        {/* <img src={diamond} /> */}
                        <LoaderDiamondIcon />
                    </span>
                    {/* { this.renderMain() } */}
                </div>
            </div>
        );
    }
}

export default LoaderComponent;
